<template>
  <svg xmlns="http://www.w3.org/2000/svg" class="position-absolute" viewBox="0 0 80 80">
    <path
      d="M80 80L53.88 5.36C52.75 2.15 49.72 0 46.32 0H33.68c-3.4 0-6.43 2.15-7.55 5.36L0 80h24l16-45.71L56 80h24z"
      class="fill-primary"
    />
    <linearGradient id="a" gradientUnits="userSpaceOnUse" x1="41.2207" y1="30.5288" x2="61.1847" y2="37.0155">
      <stop offset="0" stop-color="#010101" stop-opacity=".2" />
      <stop offset=".3" stop-color="#010101" stop-opacity=".1" />
      <stop offset=".85" stop-color="#010101" stop-opacity="0" />
    </linearGradient>
    <path d="M51 65.71l12-34.29-9.12-26.06c-.5-1.43-1.39-2.63-2.51-3.54L40 34.29l11 31.42z" fill="url(#a)" />
  </svg>
</template>

<script>
export default {};
</script>

<style></style>
